export var TpaTypes;
(function (TpaTypes) {
    TpaTypes["Hotels"] = "Hotels";
    TpaTypes["Stores"] = "Stores";
    TpaTypes["NewStores"] = "NewStores";
    TpaTypes["Bookings"] = "Bookings";
    TpaTypes["OldBookings"] = "Old_Bookings";
    TpaTypes["Video"] = "Video";
    TpaTypes["Music"] = "Music";
    TpaTypes["BandsInTown"] = "BandsInTown";
    TpaTypes["ProGallery"] = "ProGallery";
    TpaTypes["PhotoAlbums"] = "PhotoAlbums";
    TpaTypes["GetSubscribers"] = "GetSubscribers";
    TpaTypes["Blog"] = "Blog";
    TpaTypes["RestaurantsMenus"] = "RestaurantsMenus";
    TpaTypes["RestaurantsOrders"] = "RestaurantsOrders";
    TpaTypes["RestaurantsReservations"] = "RestaurantsReservations";
    TpaTypes["Restaurants"] = "Restaurants";
    TpaTypes["Events"] = "Events";
    TpaTypes["Events_Schedule"] = "Events_Schedule";
    TpaTypes["Forum"] = "Forum";
    TpaTypes["Instagram"] = "Instagram";
    TpaTypes["DeviantArt"] = "DeviantArt";
    TpaTypes["Chat"] = "Chat";
    TpaTypes["Members"] = "Members";
    TpaTypes["Blog2"] = "Blog2";
    TpaTypes["AllMembers"] = "AllMembers";
    TpaTypes["PaidPlans"] = "PaidPlans";
    TpaTypes["StickySocialBar"] = "StickySocialBar";
    TpaTypes["Groups"] = "Groups";
    TpaTypes["VirtualNumbers"] = "VirtualNumbers";
    TpaTypes["Challenges"] = "Challenges";
    TpaTypes["Ascend"] = "Ascend";
    TpaTypes["Html"] = "Html";
    TpaTypes["Loyalty"] = "Loyalty";
    TpaTypes["GiftCard"] = "GiftCard";
    TpaTypes["Members_Page"] = "Members_Page";
})(TpaTypes || (TpaTypes = {}));
//# sourceMappingURL=tpa-types.js.map